var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container py-4" },
    [
      !_vm.loading
        ? [
            _vm.state
              ? [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex justify-content-end" }, [
                    _c("p", [
                      _vm._v("วันที่ " + _vm._s(_vm.documentDate) + " ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-text" }, [
                    _c("p", [
                      _vm._v(
                        "ตามที่ท่านในฐานะผู้ให้บริการอิสระของ บริษัท บีนีท จำกัด ทราบดีว่าคุณสมบัติของการเป็นผู้ให้บริการอิสระนั้นสำคัญอย่างยิ่ง บริษัท บีนีท จำกัด จึงได้มีความจำเป็นที่ท่านจะต้องตรวจสอบประวัติอาชญากรรมในทุกปี เพื่อความปลอดภัยและความมั่นใจของลูกค้า ซึ่งขณะนี้ถึงกำหนดแล้วที่ท่านต้องตรวจประวัติอาชญากรรม"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "หากท่านต้องการให้บริษัท บีนีท จำกัด เป็นผู้ดำเนินการตรวจประวัติอาชญากรรมของท่าน ให้ท่านแสดงความยินยอมผ่านทางเอกสารฉบับนี้ โดยวิธีการและค่าใช้จ่ายในการดำเนินการ จะเป็นไปตามที่บริษัท บีนีท จำกัด กำหนด"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [
                        _vm._v(
                          "ข้าพเจ้า นาย/นาง/นางสาว " +
                            _vm._s(_vm.professionalName)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "ยินยอมให้ บริษัท บีนีท จำกัด เป็นผู้ดำเนินการตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้าได้ และข้าพเจ้ายินยอมให้บริษัท บีนีท จำกัด หักจากรายได้ของข้าพเจ้าในอัตราสัปดาห์ละ 25 บาท จนครบ 300 บาท เพื่อนำเงินดังกล่าวไปดำเนินการตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้า"
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "การให้ความยินยอมของข้าพเจ้าเป็นไปด้วยความสมัครใจ ปราศจากกการบังคับหรือชักจูง และข้าพเจ้าทราบว่าข้าพเจ้าสามารถถอนความยินยอมนี้เสียเมื่อใดก็ได้ เว้นแต่ในกรณีที่มีข้อจำกัดสิทธิตามกฎหมายหรือยังมีสัญญาระหว่างข้าพเจ้ากับ บริษัท บีนีท จำกัด ที่ให้ประโยชน์แก่ข้าพเจ้าอยู่"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "ทั้งนี้ข้าพเจ้าทราบดีว่าในกรณีที่ข้าพเจ้าไม่ได้ยินยอมให้ทาง บริษัท บีนีท จำกัด ตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้า ภายในระยะเวลาที่กำหนด บริษัท บีนีท จำกัด มีสิทธิระงับการจ่ายงานและสถานภาพการเป็นผู้ให้บริการอิสระของข้าพเจ้า"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.hasConsent
                    ? _c("div", { staticClass: "d-flex justify-content-end" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.accepted()
                              }
                            }
                          },
                          [_vm._v("ยอมรับ")]
                        )
                      ])
                    : _vm._e()
                ]
              : [_vm._m(3)]
          ]
        : [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("b-spinner", {
                  attrs: { variant: "primary", label: "Text Centered" }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("img", {
        staticClass: "rounded",
        attrs: { src: "/static/img/main-logo.svg", width: "140", alt: "..." }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "text-center mt-4" }, [
        _c("h3", [
          _vm._v(
            "เอกสารแสดงความยินยอม (Consent Form) เรื่อง “การตรวจสอบประวัติอาชญากรรม”"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "ทั้งนี้ ก่อนการแสดงเจตนา ข้าพเจ้าได้อ่านรายละเอียดจากเอกสารชี้แจงข้อมูล หรือได้รับคำอธิบายจาก บริษัท บีนีท จำกัด ถึง "
      ),
      _c("strong", [
        _vm._v("วัตถุประสงค์ในการตรวจสอบประวัติทางอาชญากรรมของข้าพเจ้า")
      ]),
      _vm._v(" และข้าพเจ้ามีความเข้าใจดีแล้ว")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("i", { staticClass: "fal fa-times-circle fa-7x text-danger" }),
      _vm._v(" "),
      _c("div", { staticClass: "pt-3" }, [
        _c("label", [_vm._v("คุณแม่บ้านยังไม่มีข้อมูล")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("label", [_vm._v("กรุณติดต่อเจ้าหน้าที่")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ef9bf02", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef9bf02","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/CriminalHistoryCheck.vue
// module id = 1959
// module chunks = 0